<template>
  <span>{{date | date}}</span>
</template>

<script>
export default {
  name: "CellRendererDate",
  computed: {
    date() {
      return this.params.value;
    }
  }
};
</script>
